class ResultsGrid extends HTMLElement {
    constructor() {
        super()

        const _data = JSON.parse(this.querySelector('script[type="application/json"]').innerHTML)
        this.$data = {
            sectionId: _data.section_id,
            paginate: _data.paginate
        }

        this.$els = {
            grid: this.querySelector('.results-grid__grid'),
            loadBtn: this.querySelector('.results-grid__load-btn'),
        }

        if (this.$els.loadBtn) {
            this.$els.loadBtn.addEventListener('click', this.loadMore.bind(this))
        }
    }

    loadMore() {
        if (this.$data.paginate.current_page >= this.$data.paginate.pages) return 

        this.$data.paginate.current_page++
        //const url = `${window.location.pathname}?section_id=${this.$data.sectionId}&${this.$data.paginate.page_param}=${this.$data.paginate.current_page}`
        const url = `${window.location.pathname}?section_id=${this.$data.sectionId}&page=${this.$data.paginate.current_page}`

        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const newItems = html.querySelectorAll('.results-grid__item')
                const firstNewItem = newItems[0]

                // add the new items to the grid
                this.$els.grid.append(...newItems)

                // focus the first new item
                firstNewItem.setAttribute('tabindex', -1)
                firstNewItem.focus()

                // hide the btn if necessary
                if (this.$data.paginate.current_page >= this.$data.paginate.pages) {
                    this.$els.loadBtn.classList.add('tw-hidden')
                }
            })
    }
}
customElements.define('results-grid', ResultsGrid);